import { Link } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";

/*!*******************************************************************************!
  !*** INTEREST RATE API CONFIG                                                       ***!
  \*******************************************************************************/
export const apiConfig = {
  Loanproducts: BOM.baseUrl("loanproducts"),
  ProductMix: BOM.baseUrl("loanproducts?associations=productMixes"),
  ProductMixTemplate: BOM.baseUrl("loanproducts/template?isProductMixTemplate=true"),
};

/*!*******************************************************************************!
  !*** INTEREST RATE LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
    generalInfo: "General Information",
    productMix: "Product Mix",
    productName: "Product Name",
    productLoan: "Product Loan",
    newProductMix: "New Product Mix",
    manageProductMix:"Manage Product Mix",
    editProductMix: "Edit Product Mix",
    newProductMixMsg: "Product Mix was successfully created",
    productMixId: "Product Id",
    allowedProducts: "Allowed products",
    restrictedProducts: "Restricted products",
    productMixDetail: "Product Mix Detail",
    editProductMix: "Edit Product Mix",
    productMixSetup: "Product Mix Setup",
    loanAccountsInfo: "Loan accounts Information",
    deleteProductMixMsg: "Product Mix was successfully deleted",
    tooltipInfo:"The Product Mix function enables a financial institution to define rules that restrict the loan accounts that may be held by a client at the same time. FinSys checks a client's active loan accounts when a new loan is being disbursed. If there is a conflict between the client's active loan accounts and the loan account to be disbursed, an error will result and the new loan account will not be disbursed. "
};

/*!*******************************************************************************!
    !*** INTEREST RATE STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  manageBreadcrumbItems: [{ title: labelConfig.manageProductMix }],
  detailBreadcrumbItems: [
    { title: <Link to="/prd0606">{labelConfig.manageProductMix}</Link> },
    { title: labelConfig.productMixDetail },
  ],
  newBreadcrumbItems: [
    { title: <Link to="/prd0606">{labelConfig.manageProductMix}</Link> },
    { title: labelConfig.newProductMix },
  ],
  editBreadcrumbItems: [
    { title: <Link to="/prd0606">{labelConfig.editProductMix}</Link> },
    { title: labelConfig.newProductMix },
  ],
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
};

